interface Adaptation {
  chat_id: string;
}

export function livechatTemplatesStartCreateAdapter(
  attendanceId: string,
): Adaptation {
  return {
    chat_id: attendanceId,
  }
}
